module.exports = __webpack_public_path__ + "static/media/11.2c8a95fe.jpg";